import { getTeamUsersQuery, selectedTeamIdQuery, teamQuery } from '../../../queries/teamQuery';
import { userQuery } from '../../../queries/userQuery';

import type { QueryClient } from '@tanstack/react-query';
export const teamsPeopleLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const teamIdQuery = selectedTeamIdQuery('selectedTeamID');
	const teamId = await queryClient.ensureQueryData(teamIdQuery);
	const user = await queryClient.ensureQueryData(userQuery);
	const userData = await queryClient.ensureQueryData(getTeamUsersQuery({ teamId: teamId?.[0] || '' }));

	return {
		teamId,
		user,
		userData,
		team: await queryClient.ensureQueryData(teamQuery({ teamId: teamId?.[0] || '' })),
	};
};
